module.exports = __webpack_public_path__ + "img/shiba-loading.92480b58.png";